import React from 'react';
import { PageHeader, Page, PageContent, Box, Text } from 'grommet';
import { DashboardGrid } from '../../components/DashboardGrid';
//import { AverageResponseTimes } from '../../components/AverageResponseTimes';
import HomeTilesJSON from '../../data/home/HomeTiles.json';

export const Home = () => {

  return (
  
    <Page flex="grow" background="background-back">

      <Box
        background="url('/images/hpe-tech-surface.jpg')"
        height={{ min: '140px', max: 'auto' }}
        margin={{ top: 'none' }}
        pad={{ bottom: 'small' }} 
        style={{ backgroundSize: 'cover', backgroundPosition: 'center' }} 
      >
        <Box margin={{ top: 'none', left: 'large' }} pad={{ horizontal: 'small' }}>
          <PageHeader
            pad={{ top: '5px', bottom: '10px' }}
            title={<Text color="white" size="xxlarge" weight="bolder" style={{ fontWeight: 'bold' }}>HPE Tech Con</Text>}
            subtitle={'A key innovation engine powered by YOU'}
            style={{ color: 'white' }}
            size='medium'
          />
        </Box>
      </Box>

      <PageContent flex="grow">
        <DashboardGrid dataSource={HomeTilesJSON} />
      </PageContent> 

    </Page>
  );
};